export default "__VITE_ASSET__C6sB$PDt__"